// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import global from "./assets/js/global";

import VueBus from "vue-bus";
import Vant from "vant";
import "vant/lib/index.css";
import "vant/lib/icon/local.css";
import "../static/main.css";
import "./assets/js/exitApp";
import "./assets/css/iconfont.css";
import FastClick from "fastclick";
import store from "./store/index.js";
import Navigation from 'vue-navigation'

// import Api from './config/api'
import "babel-polyfill";
import "event-source-polyfill";
if ("addEventListener" in document) {
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      FastClick.attach(document.body);
    },
    false
  );
}

FastClick.prototype.focus = function (targetElement) {
  var length;
  var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent);

  // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
  if (
    deviceIsIOS &&
    targetElement.setSelectionRange &&
    targetElement.type.indexOf("date") !== 0 &&
    targetElement.type !== "time" &&
    targetElement.type !== "month"
  ) {
    length = targetElement.value.length;
    targetElement.setSelectionRange(length, length);
    targetElement.focus();
  } else {
    targetElement.focus();
  }
};

import VConsole from "vconsole";

// const isDebug = true;
// 本地开发调试注入vConsole
// if (global.isApp) {
// new VConsole();
// }

/** 点击事件添加音频文件
 *  用法一：给发生点击事件的元素添加 clickMusic='true'属性
 *  用法二：在事件函数中通过 this.clickButton() 调用
 */
// 引入音频文件[重点]
document.body.addEventListener("click", function (e) {
  let event = e || window.event;
  let target = event.target || event.srcElement;
  let clickMusic = target.getAttribute("clickMusic");
  if (clickMusic === "true") Vue.prototype.clickButton();
  else return false;
});

Vue.use(VueBus);
Vue.use(Vant);
Vue.config.productionTip = false;
Vue.prototype.$global = global;
// Vue.prototype.api = Api

Vue.filter("toFixed", function (number, scale) {
  return new Number(number).toFixed(scale);
});
Vue.filter("noData", function (string) {
  return string ? string : "--";
});
// 过滤html中过的null undefined NaN等值
Vue.filter("filterErr", (value) => {
  return !!value ? value : "--";
});
Vue.use(Navigation, {
  router,
  store
}) //←注意这一句应该在router实例化(router = new VueRouter({})之后
// Vue.use({
//   router,
//   store,
// });
Vue.config.productionTip = false;
console.log(global.isApp);
/* eslint-disable no-new */
if (global.isApp) {
  window.apiready = function () {
    console.log("api:", api);
    api.setStatusBarStyle({
      style: "dark",
      color: "transparent",
    });
    api.parseTapmode();
    // api.setFullScreen({
    //   fullScreen: true
    // });
    new Vue({
      el: "#app",
      router,
      store,
      components: {
        App,
      },
      template: "<App/>",
    });
    // api.openWin({
    //   name: 'login',
    //   url: './index.html',
    //   allowEdit: true,
    // });
    // var systemType = api.systemType
    // if (systemType === 'ios') {
    //   api.openFrame({
    //     name: 'frame',
    //     url: './index.html', //上传打包时使用
    //     // url: 'http://192.168.99.101:8010/html/index.html', //调试时使用
    //     rect: {
    //       x: 0,
    //       y: 0,
    //       w: 'auto',
    //       h: 'auto'
    //     },
    //     allowEdit: true,
    //   });
    // }

    // 移除启动页
    // console.log('移除启动页')
    // api.removeLaunchView({
    //   animation: {
    //       type: 'fade',
    //       duration: 100
    //   }
    // });
    // exitApp();
    // $api.rmStorage('apptabal')
  };
} else {
  var vm = new Vue({
    el: "#app",
    router,
    store,
    components: {
      App,
    },
    template: "<App/>",
  });
}



// WEBPACK FOOTER //
// ./src/main.js